import styled from '@emotion/styled';

import { screens } from '~/styles/theme';

export const Medias = styled.div`
  width: 100%;
  display: block;
  margin-bottom: 1.5rem;

  .is-pulled-right {
    float: right;
    color: #4b71fc;
    font-size: 13px;
  }

  .is-pulled-right + .is-pulled-right {
    margin-right: 1.5rem;
  }

  .group {
    background: white;
    border: 1px solid rgba(228, 231, 237, 0.8);
    padding: 1.5rem;
    text-align: center;

    input {
      display: none;
    }

    .first-upload {
      margin: 1.5rem;
      img {
        width: 80px;
      }

      h4 {
        color: #d3dbe2;
        font-size: 14px;
      }
    }
  }

  .is-clearfix {
    &:after {
      clear: both;
      content: ' ';
      display: table;
    }
  }

  .dropzone-hide {
    display: none;
  }
  .dropzone-active {
    border: 3px dashed #00aeef;
  }

  .aspect-ratio {
    position: relative;
    display: block;
    background: #fafbfc;
    padding: 0;

    &:before {
      z-index: 1;
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 1px solid rgba(195, 207, 216, 0.3);
    }

    &.isDragging:before {
      border: 1px solid red;
    }
  }

  .aspect-ratio--square {
    width: 100%;
    padding-bottom: 100%;
    flex-shrink: 0;
  }

  .aspect-ratio__content {
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }

  .loading-in-progress {
    padding: 0 0 1.5rem 0;
    display: block;
    text-align: center;
  }
`;

export const List = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-gap: 1.5rem;
  grid-template-columns: repeat(3, 1fr);

  @media screen and (min-width: ${screens.md}) {
    grid-template-columns: repeat(4, 1fr);
  }

  > li {
    position: relative;
    box-sizing: border-box;

    // &:first-of-type {
    //   grid-column: 1 / 3;
    //   grid-row: 1 / 3;
    // }

    figure {
      margin: 0;
    }

    &.isOver .aspect-ratio:before {
      border: 1px solid green !important;
    }

    .hover-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 3;
      background: rgba(49, 55, 61, 0.75);

      opacity: 0;
      transition: opacity 0.1s ease-in-out;

      &:hover {
        opacity: 1;
      }

      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;

      > div {
        width: 100%;
      }
    }
  }

  .aspect-ratio {
    position: relative;
    display: block;
    background: #fafbfc;
    padding: 0;

    &:before {
      z-index: 1;
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 1px solid rgba(195, 207, 216, 0.3);
    }

    &.isDragging:before {
      border: 1px solid red;
    }
  }

  .aspect-ratio--square {
    width: 100%;
    padding-bottom: 100%;
    flex-shrink: 0;
  }

  .aspect-ratio__content {
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }
`;
